import {ACT_ACTION} from './types';

export default function (key) {
    return {
        type: ACT_ACTION,
        payload: {
            currentDirection: key
        },
    }
}



/** WEBPACK FOOTER **
 ** ./src/modules/finance/actions/ChangeDirection.js
 **/